import { render } from "./AddPinToBoardIcon.vue?vue&type=template&id=383b0f53"
import script from "./AddPinToBoardIcon.vue?vue&type=script&lang=js"
export * from "./AddPinToBoardIcon.vue?vue&type=script&lang=js"
script.render = render

export default script